import React from "react";
import ProfileHeader from "./ProfileHeader";
import ProfileTabs from "./ProfileTabs";
import { ProfileData } from "@/hooks/useProfiles";
import { RichTextDisplay } from "@/components/ui/rich-text-display";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Clock } from "lucide-react";

interface ProfilePageContentProps {
  profile: ProfileData & {
    derivedProfession?: string | null;
  };
  placeholderImage: string;
  isSimplifiedView?: boolean;
  openPortfolioModal?: (item: import("@/hooks/profile").PortfolioItem) => void;
  onClosePortfolioModal?: () => void;
}
const ProfilePageContent: React.FC<ProfilePageContentProps> = ({
  profile,
  placeholderImage,
  isSimplifiedView = false,
  openPortfolioModal,
  onClosePortfolioModal,
}) => {
  return (
    <>

      <div className="relative">
        {/* Warm gradient background applied to the content area */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute warm-gradient"></div>
          <div
            className="absolute inset-0 opacity-40"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z' fill='%23FFDFCE' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E\")",
              opacity: "0.4",
            }}
          ></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 relative z-10 py-[48px]">
          {isSimplifiedView && (
            <Alert variant="warning" className="mb-6">
              <Clock className="h-4 w-4" />
              <AlertDescription>
                Viewing simplified profile due to large data size. Some
                portfolio items may be limited.
              </AlertDescription>
            </Alert>
          )}
          <ProfileHeader
            profile={profile}
            placeholderImage={placeholderImage}
          />
          {profile.bio && <RichTextDisplay content={profile.bio} className="prose mx-auto my-6 max-w-3xl" />}
          <ProfileTabs
            profile={profile}
            isSimplifiedView={isSimplifiedView}
            openPortfolioModal={openPortfolioModal}
            onClosePortfolioModal={onClosePortfolioModal}
          />
        </div>
      </div>
    </>
  );
};
export default ProfilePageContent;
